<template>
  <LoadingIndicator
    v-if="loadingData"
    class="mt-5"
  />

  <PageWrap
    v-else
    :page-title="pageTitle"
  >
    <AssessorForm
      :data="formData"
      :editing="isEditing"
      :errors="formErrors"
      @update="updateForm"
      @updateUser="updateUser"
      @desvincularUsuario="desvincularUsuario"
      @desvincularZona="desvincularZona"
      @showPassword="showChangePasswordModal"
      @showModal="showChangePasswordModal"
      class="mb-5"
    />

    <BfButton
      v-if="!isEditing"
      @click="createTasador"
    >
      Guardar
    </BfButton>

    <BfButton
      v-if="isEditing"
      variant="red"
      @click="showDeleteModal"
    >
      Eliminar
    </BfButton>

    <DeleteWarningModal
      v-model="displayDeleteModal"
      title="¿Desea eliminar este tasador?"
      @confirm-deletion="deleteEntry"
    />

    <ChangePasswordModal
      title="Cambiar contraseña"
      v-model="displayChangePasswordModal"
      @updatePassword="updatePassword"
    />
  </PageWrap>
</template>

<script>
import AssessorForm from '@/components/FormGroups/AssessorForm';
import FormSectionHeader from '@/components/FormSectionHeader';
import LoadingIndicator from '@/components/LoadingIndicator';
import PageWrap from '@/components/PageWrap';
import DeleteWarningModal from '@/components/DeleteWarningModal';
import ChangePasswordModal from '@/components/FormModals/ChangePasswordModal';

import { assessorAPI } from '@/api';

export default {
  name: 'AssessorsDetail',

  props: {
    id: {
      type: String,
    },
  },

  data() {
    return {
      formData: {},
      formErrors: {},
      loadingData: false,
      displayDeleteModal: false,
      displayChangePasswordModal: false,
    };
  },

  async created() {
    this.loadingData = true;

    try {
      if (this.isEditing) {
        await this.loadData();
      } else {
        await this.prepareForm();
      }
    } finally {
      this.loadingData = false;
    }
  },

  methods: {
    async updatePassword(newPassword) {
      await this.updateForm({ key: 'password', value: newPassword });
      this.displayChangePasswordModal = false;
      console.log('end');
    },
    async loadData() {
      const {
        data: [assessorData],
      } = await assessorAPI.get(this.id);

      this.formData = assessorData;
    },

    async prepareForm() {
      const { data } = await assessorAPI.preCreate();
      this.formData = data;
    },

    async updateForm({ key, value }) {
      const newData = { [key]: value };

      console.log(newData);

      if (!this.isEditing) {
        this.formData = { ...this.formData, ...newData };
      } else {
        this.formErrors = {};

        try {
          const { data, message } = await assessorAPI.update({
            id: this.id,
            data: newData,
          });

          this.formData = data;
          this.$bfNotify({ title: 'Actualizado', message, type: 'success' });
        } catch ({ errors }) {
          this.formErrors = errors;
          this.$bfNotify({
            title: 'Error',
            message: 'Existe un error con tus datos',
            type: 'error',
          });
        }
      }
    },

    async updateUser({ key, value }) {
      const newData = {
        [key]: value,
        tasadorId: this.formData.id,
      };


      console.log(newData);
    },

    async createTasador() {
      try {
        this.formErrors = {};
        const { data, message } = await assessorAPI.create(this.formData);

        this.$bfNotify({ title: 'Guardado', message, type: 'success' });
        this.$router.replace({ name: 'tasador', params: { id: `${data.id}` } });
      } catch ({ errors, message }) {
        this.formErrors = errors;
        this.$bfNotify({ title: 'Error', message: 'Existe un error con tus datos', type: 'error' });
      }
    },

    async showDeleteModal() {
      this.displayDeleteModal = true;
    },

    async showChangePasswordModal() {
      this.displayChangePasswordModal = true;
    },
    async deleteEntry() {
      try {
        const { message } = await assessorAPI.delete(this.id);

        this.$bfNotify({ title: 'Eliminado', message, type: 'success' });
        this.$router.replace({ name: 'tasadores' });
      } catch ({ message }) {
        this.$bfNotify({ title: 'Error', message, type: 'error' });
      }
    },

    async desvincularUsuario() {
      this.updateForm({ key: 'user_id', value: null });
    },

    async  desvincularZona() {
      this.updateForm({ key: 'zona_id', value: null });
    },
  },

  computed: {
    isEditing() {
      return !!this.id;
    },

    pageTitle() {
      return this.isEditing ? `Usuario: ${this.formData.nombre || ''}` : 'Crear usuario';
    },
  },

  components: {
    AssessorForm,
    DeleteWarningModal,
    ChangePasswordModal,
    FormSectionHeader,
    LoadingIndicator,
    PageWrap,
  },
};
</script>
